import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MenuUploader from '../components/TenantMedia/MenuUploader.tsx';
import GalleryManager from '../components/TenantMedia/GalleryManager.tsx';
import '../components/TenantMedia/TenantMedia.css';
import { getLocations } from '../services/apiService.ts';

const TenantMediaPage: React.FC = () => {
  const { tenantId } = useParams<{ tenantId: string }>();
  const navigate = useNavigate();
  
  const [locationId, setLocationId] = useState<number | null>(null);
  const [locations, setLocations] = useState<Array<{ id: number; name: string }>>([]);

  useEffect(() => {
    (async () => {
      if (!tenantId) return;
      try {
        const list = await getLocations(tenantId);
        const opts = (Array.isArray(list) ? list : (list?.content || [])).map((l: any) => ({ id: l.id || l.locationId || l.location_id, name: l.name }));
        setLocations(opts);
        if (opts.length > 0) setLocationId(opts[0].id);
      } catch {
        setLocations([]);
        setLocationId(null);
      }
    })();
  }, [tenantId]);

  if (!tenantId) {
    return (
      <div className="error-page">
        <h2>Invalid tenant ID</h2>
        <button onClick={() => navigate('/tenants')} className="btn btn-primary">
          Back to Tenants
        </button>
      </div>
    );
  }

  const tenantIdNum = parseInt(tenantId);

  return (
    <div className="tenant-media-page">
      <div className="page-header">
        <button 
          onClick={() => navigate(`/tenants/${tenantId}`)}
          className="btn btn-secondary"
          style={{ marginBottom: '1rem' }}
        >
          <svg className="btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                  d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Back to Tenant Details
        </button>
        
        <h1 className="page-title">Media Management</h1>
        <p className="page-subtitle">
          Upload and manage menu PDF and photo gallery for Tenant #{tenantId}
        </p>

        <div className="selector-row">
          <label htmlFor="locationSelect">Location</label>
          <select
            id="locationSelect"
            value={locationId ?? ''}
            onChange={e => setLocationId(Number(e.target.value))}
          >
            {locations.map(l => (
              <option key={l.id} value={l.id}>{l.name || `Location #${l.id}`}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="media-grid">
        <MenuUploader tenantId={tenantIdNum} locationId={locationId ?? 0} />
        <GalleryManager tenantId={tenantIdNum} locationId={locationId ?? 0} />
      </div>

      <ToastContainer 
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default TenantMediaPage;
